export default __webpack_public_path__ + "static/media/166.91ea19ad.gif";